// extracted by mini-css-extract-plugin
export default {"wrapper":"l55M9","icon":"EkUCE","iconCopied":"lax7F","text":"pkdxF","content":"cjC3Z","dark":"W7VDR","iconCopy":"D8qT4","light":"ehIsR","copied":"Ao26Q"};